// Extrait de ClinicAdminDashboard.js (handover bloc F3-A) — 8 onglets, libellés/compteurs inchangés (compteurs en badges).
import { BarChart3, TrendingUp, Users, UserCheck, BookOpen, FlaskConical, Phone, Plug } from "lucide-react";
import { SectionTabs } from "@/components/shared/SectionTabs";

export default function ClinicAdminTabs({ activeTab, onTabChange, patientTotal, users, educationContents }) {
  const tabs = [
    { id: "overview", label: "Vue d'ensemble", icon: BarChart3 },
    { id: "performance", label: "Performance", icon: TrendingUp },
    { id: "patients", label: "Patients", icon: Users, count: patientTotal },
    { id: "team", label: "Équipe", icon: UserCheck, count: users.length },
    { id: "education", label: "Éducation", icon: BookOpen, count: educationContents.length },
    { id: "protocols", label: "Protocoles", icon: FlaskConical },
    { id: "reminders", label: "Rappels RDV", icon: Phone },
    { id: "connector", label: "Connecteur RDV", icon: Plug },
  ];
  return <SectionTabs tabs={tabs} active={activeTab} onChange={onTabChange} />;
}
